import type { Preferences } from '../../shared/contracts';
import { Field } from './Primitives';

export function ExportBackgroundEditor({ value, onChange, disabled = false }: {
  value: Preferences['exportBackgrounds']; onChange: (value: Preferences['exportBackgrounds']) => void; disabled?: boolean;
}) {
  return <fieldset disabled={disabled} className="a240-export-backgrounds"><legend>Export backgrounds</legend>
    <p>PNG and SVG default to transparent backgrounds. Existing saved backgrounds are retained, including white. Entity fills and relationship lines remain visible.</p>
    {(['png', 'svg'] as const).map(format => {
      const current = value?.[format] ?? { mode: 'transparent' as const, color: '#ffffff', provenance: 'default' as const };
      return <div className="form-row" key={format}>
        <Field label={`${format.toUpperCase()} background`}><select aria-label={`${format.toUpperCase()} background`} value={current.mode}
          onChange={event => onChange({ ...value, [format]: { ...current, mode: event.target.value as 'transparent' | 'solid', provenance: 'explicit' } })}>
          <option value="solid">Solid color</option><option value="transparent">Transparent</option>
        </select></Field>
        <Field label={`${format.toUpperCase()} background color`} hint={current.mode === 'transparent' ? 'Remembered for solid-color exports.' : 'White by default; independent of the canvas.'}>
          <div className="a210-color-field"><input aria-label={`${format.toUpperCase()} background color`} type="color" value={current.color}
            disabled={disabled || current.mode === 'transparent'} onChange={event => onChange({ ...value, [format]: { ...current, color: event.target.value, provenance: 'explicit' } })}/><code>{current.color.toUpperCase()}</code>
            <button type="button" disabled={disabled || current.mode === 'transparent'} onClick={() => onChange({ ...value, [format]: { ...current, color: '#ffffff', provenance: 'explicit' } })}>White</button>
          </div>
        </Field>
      </div>;
    })}
  </fieldset>;
}
